import { useAuthContext } from '@/contexts/auth-context';

export function useAccountSlug() {
  const { account } = useAuthContext();

  if (!account) throw new Error('Missing account');

  return account.slug;
}
